/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2025 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2025 - Finnish Meteorological Institute (FMI)
 * Copyright 2025 - The Norwegian Meteorological Institute (MET Norway)
 * */

import React from 'react';
import { useSelector } from 'react-redux';
import { useSetupDialog, uiTypes } from '@opengeoweb/store';
import DataExplorerInfo from './DataExplorerInfo';
import type { DataExplorerTypes } from '../../store';
import { dataExplorerSelectors } from '../../store';
import { useFetchItem } from '../../utils/dataexplorer-api/hooks';

export const DataExplorerInfoConnect: React.FC = () => {
  const { dialogOrder, setDialogOrder, onCloseDialog, isDialogOpen, uiSource } =
    useSetupDialog(uiTypes.DialogTypes.DataExplorerInfo);

  const selectedId = useSelector(
    (store: DataExplorerTypes.DataExplorerModuleState) =>
      dataExplorerSelectors.getSelectedDatasetId(store),
  );

  const baseUrl = useSelector(
    (store: DataExplorerTypes.DataExplorerModuleState) =>
      dataExplorerSelectors.getDiscoveryCatalogueURL(store),
  );

  const { data: featureInfo } = useFetchItem(baseUrl, selectedId);

  return React.useMemo(() => {
    return (
      <DataExplorerInfo
        datasetLink={baseUrl}
        featureInfo={featureInfo}
        isOpen={isDialogOpen}
        onClose={onCloseDialog}
        onMouseDown={setDialogOrder}
        order={dialogOrder}
        source={uiSource}
        startPosition={{ top: 85, left: 50 }}
      />
    );
  }, [
    baseUrl,
    dialogOrder,
    isDialogOpen,
    featureInfo,
    onCloseDialog,
    setDialogOrder,
    uiSource,
  ]);
};
